<template>

	<span :class="{wrap:!settings.currentPosition}" v-if="!hasProjectArray">

		<span v-if="settings.currentPosition" v-html="settings.currentPosition" class="pos" />

  	<TableButton :settings="settings" @clicked="clicked" v-if="!settings.currentPosition" />

  </span>

  <span :class="{wrap:!settings.currentPosition}" v-else>

    <div v-for="(p,i) in trackedProjects" :key="p.projectId" :class="{'mtop':i>0}">

      <span v-html="p.name" class="pos" /> - <span v-if="p.currentPosition" v-html="p.currentPosition" class="pos" />

    </div>

    <span v-if="shouldShowAll" @click="showAll=!showAll" class="show-all" v-html="showAll ? 'Show less' : 'Show '+(allTrackedProjects.length-maxForNotShowAll)+' more...'" />

    <div v-if="untrackedProjects.length&&trackedProjects.length" class="not-tracked">Not tracked in {{untrackedProjects.length}} rank tracking project{{untrackedProjects.length > 1 ? 's' : ''}}.<span v-if="untrackedProjectsFullAccess.length<untrackedProjects.length"> You have full access to {{untrackedProjectsFullAccess.length}} of these.</span></div>

    <TableButton :settings="{...settings, label: 'Add Tracking', projectIds: untrackedProjectsFullAccess}" @clicked="clicked" v-if="untrackedProjectsFullAccess.length" />

  </span>

</template>

<script>
import TableButton from './TableButton.vue'
export default {
  name: 'TableCurrentPosition',
  props: ['settings'],
  components: { TableButton },
  data() {
    return {
      showAll: false,
      maxForNotShowAll: 3
    }
  },
  computed:{
    hasProjectArray () {

      return !!this.settings.projects && Array.isArray( this.settings.projects );

    },
    shouldShowAll () {
      return this.allTrackedProjects.length > this.maxForNotShowAll;
    },
    allTrackedProjects () {
      return this.settings.projects.filter( p => !!p.currentPosition );
    },
    trackedProjects () {

      return this.showAll ? this.allTrackedProjects : this.allTrackedProjects.slice(0, this.maxForNotShowAll);

    },
    untrackedProjects () {

      return this.settings.projects.filter( p => !p.currentPosition );

    },
    untrackedProjectsFullAccess () {

      return this.settings.projects.filter( p => !p.currentPosition && p.access === 'full-access' );

    },
    untrackedProjectIds () {

      return this.untrackedProjects.map( p => p.projectId );

    }
  },
  methods: {
  
    clicked(e) {

      if ( this.settings.click ) {

        this.$emit('clicked',null);

      }

    }

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
@import './../../assets/css/less/_helper.less';
.wrap {
	padding: 0 !important;
  max-width: 200px;
}
.pos {
  font-weight: 900;
}
.not-tracked {
  margin-top: 5px;
}
.mtop {
  margin-top: 5px;
}
.show-all {
  cursor: pointer;
  display: inline-block;
  margin-top: 5px;
  font-style: italic;
  .trans;
  &:hover {
    color: @formDefaultColour;
  }
}
</style>
